import { CheckIcon } from "@heroicons/react/24/outline"

interface Props {
  animationDelayMs: number
  emoji?: string
  indicator: "radio" | "checkbox" | "none"
  isSelected: boolean
  label: string
  onClick: () => void
}

export default function OptionButton({
  animationDelayMs,
  emoji,
  indicator,
  isSelected,
  label,
  onClick,
}: Props) {
  return (
    <button
      aria-pressed={isSelected}
      className={`vm-option animate-fade-up ${isSelected ? "vm-option-selected" : ""}`}
      onClick={onClick}
      style={{ animationDelay: `${animationDelayMs}ms` }}
      type="button"
    >
      {emoji && (
        <span aria-hidden className="text-2xl leading-none">
          {emoji}
        </span>
      )}

      <span className="grow">{label}</span>

      {indicator !== "none" && (
        <span
          className={`flex h-6 w-6 shrink-0 items-center justify-center border-2 transition-colors duration-200 ${
            indicator === "radio" ? "rounded-full" : "rounded-md"
          } ${isSelected ? "border-vm-primary bg-vm-primary" : "border-vm-line bg-vm-cream"}`}
        >
          {isSelected && (
            <CheckIcon className="h-4 w-4 animate-check-pop text-white" />
          )}
        </span>
      )}
    </button>
  )
}
